import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=7e207d0a&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"
import style0 from "./admin.vue?vue&type=style&index=0&id=7e207d0a&prod&lang=css"
import style1 from "./admin.vue?vue&type=style&index=1&id=7e207d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e207d0a",
  null
  
)

export default component.exports